import { useQuery } from '@tanstack/react-query'
import { dbConsoleService } from '@/services/dbConsole'

/** The people the requester may name as the second approver (never themself). */
export function useExportApprovers() {
  return useQuery({
    queryKey: ['db-console', 'export-approvers'],
    queryFn: dbConsoleService.listExportApprovers,
    staleTime: 60_000,
  })
}
